module.exports = __webpack_public_path__ + "static/media/diamond.8d2abe5e.png";